import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { Icon } from '../Icon';

import { ExpandedProperties } from './Expander.types';

export const StyledTitleContainer = styled('button')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        align-items: center;
        padding: ${theme.tggSpacing([0, 0, 0, rem(1.5)], [0, 0, 0, 3.75])};
        margin: ${theme.tggSpacing(0, 0)};
        color: ${theme.palette.common.blue};
        cursor: pointer;
        background: none;
        border: none;

        ${theme.breakpoints.up('desktop')} {
            padding:  ${theme.tggSpacing([0, 0, 0, rem(3)], [0, 0, 0, 7.5])};
        }
	`}
`;

export const StyledTitle = styled('p')`
    ${({ theme }: { theme: Theme }) => theme.typography.bodySmall};
    ${({ theme }: { theme: Theme }) => `
        display: inline-block;
        padding: ${theme.tggSpacing(rem(1), 2.5)};
        margin: ${theme.tggSpacing(0, 0)};
        text-decoration: underline;

        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing(rem(1.2), 5)};
        }
	`}
`;

export const StyledIconContainer = styled('div')<ExpandedProperties>`
    position: relative;
    display: inline-block;
    line-height: 0;
    ${({ $expanded }) => ($expanded ? 'transform: rotate(45deg);' : '')};
    transition: all 0.2s;
`;

export const StyledIcon = styled(Icon)`
    cursor: pointer;
`;

export const StyledContent = styled('div')<
    ExpandedProperties & { theme: Theme }
>`
    ${({ theme }) => theme.typography.text_16};
    ${({ theme, $expanded }) => `
        max-height: ${$expanded ? '100vh' : '0'};
        padding: ${theme.tggSpacing([0, rem(4), 0, rem(4)], [0, 10, 0, 10])};
        overflow: hidden;
        transition: all 0.7s;
        transition-timing-function: ${
            $expanded ? 'ease-out' : 'cubic-bezier(0,1,0,1)'
        };
	`}
`;
